import { CommonProductModel, Feature, PromoModel } from '~/core/models';

export enum ApplianceSource {
  CUSTOMER = 'CUSTOMER',
  IN_STORE = 'In-Store',
  PROGRAM = 'Program',
}

export enum ApplianceType {
  COOKTOP = 'COOKTOP',
  DISHWASHER = 'DISHWASHER',
  FAUCET = 'FAUCET',
  RANGE = 'RANGE',
  REFRIGERATOR = 'REFRIGERATOR',
  SINK = 'SINK',
  SINK_LABOR = 'SINK_LABOR',
  ELECTRICAL_CUTOUT = 'ELECTRICAL_CUTOUT',
  FAUCET_CUTOUT = 'FAUCET_CUTOUT',
}

export const AppliancesAllowedOnShapes = [
  ApplianceType.COOKTOP,
  ApplianceType.DISHWASHER,
  ApplianceType.FAUCET,
  ApplianceType.RANGE,
  ApplianceType.SINK,
  ApplianceType.SINK_LABOR,
  ApplianceType.ELECTRICAL_CUTOUT,
  ApplianceType.FAUCET_CUTOUT,
];

export const AppliancesAllowedOutsideShapes = [
  ApplianceType.DISHWASHER,
  ApplianceType.RANGE,
  ApplianceType.REFRIGERATOR,
];

export type ApplianceModelId = number;

export interface ApplianceModel extends CommonProductModel {
  applianceType: ApplianceType;
  brand: string;
  beautyShotImageUrl: string | null;
  depth: number | null; // actual depth of the appliance in inches
  discountPercentage: number | null;
  features: Feature[];
  height: number;
  id: ApplianceModelId;
  imageUrl: string | null;
  // @TODO - change it to an enum when we know the values that are coming from the backend and their meaning
  ironType?: number;
  length: number; // actual length of the appliance (x-dimension when placing on design) in inches
  model?: string;
  modelNumber?: string;
  priceWithoutDiscount: number;
  productSource: ApplianceSource;
  promos: PromoModel[];
  rank: number;
  type: string;
  uuid: string;
  width: number; // actual width of the appliance (y-dimension when placing on design) in inches
}
